import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createSlots as _createSlots, withModifiers as _withModifiers, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "container-fix-padding" }
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = { class: "test-menu bm-3 d-flex" }
const _hoisted_4 = { class: "d-flex" }
const _hoisted_5 = { class: "exam-title" }
const _hoisted_6 = {
  key: 1,
  class: "exam-price float-right"
}
const _hoisted_7 = { class: "user-exam-created-at" }
const _hoisted_8 = { class: "mt-2 mb-0" }
const _hoisted_9 = { class: "d-flex" }
const _hoisted_10 = { class: "px-4" }
const _hoisted_11 = { class: "d-flex" }
const _hoisted_12 = { class: "col-lg-12 category-parent mt-2" }
const _hoisted_13 = { class: "p-3" }
const _hoisted_14 = { class: "d-flex" }
const _hoisted_15 = { class: "col-lg-12 category-parent mt-2" }

import { ref, computed, onMounted, onBeforeUnmount, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import ExamListCategory from '../atoms_molecules/ExamListCategory.vue'
import { LETTER_FORMAT } from '../../utils/constants'
import Exam from '../../models/exam'
import { examState } from '../../stores/exam'
import { headerState } from '../../stores/header'
import { footerState } from '../../stores/footer'
import Category from '../../models/category'
import { userState } from '../../stores/user'
import { format } from 'date-fns'
import { checkMobile } from '../../utils/utils'
import { getQueryString, getQueryNumber } from '../../../../helpers/route-helper'


export default /*@__PURE__*/_defineComponent({
  __name: 'ExamList',
  setup(__props) {

const route = useRoute()
const router = useRouter()

const isMobile = ref(false)
const mobile = ref(checkMobile())
const drawerRight = ref(!mobile.value)
const isLoadingSearch = ref(false)
const items = ref<string[]>([])
const model = ref("")
const search = ref("")

const breadcrumbs = [
  {
    text: 'クラスルーム',
    disabled: false,
    exact: true,
    to: '/classroom/'
  },
  {
    text: 'テスト一覧',
    disabled: false,
    exact: true,
    to: '/classroom/exam-list'
  }
]

const exams = computed(() => examState.listExam.list)
const user = computed(() => userState.user)
const categories = computed(() => examState.listExam.categories)
const isLoading = computed(() => examState.listExam.isLoading)
const pagination = computed(() => examState.listExam.pagination)

// Type-safe computed properties for route query params
const currentListId = computed(() => getQueryString(route.query, 'list_id'))
const currentListIdNumber = computed(() => getQueryNumber(route.query, 'list_id'))

const findCategoryById = (id: number) => {
  for (let index = 0; index < categories.value.length; index++) {
    const category = categories.value[index].find(id)
    if (category) {
      return category
    }
  }
  return null
}

const currentExams = computed(() => {
  const listId = currentListIdNumber.value
  if (!listId) {
    return exams.value
  }
  const category = findCategoryById(listId)
  return category ? category.getExams(exams.value) : []
})

const title = computed(() => {
  const listId = currentListIdNumber.value
  if (!listId) {
    return 'すべてのテスト'
  }
  const category = findCategoryById(listId)
  return category ? `${category.name}のテスト` : ''
})

const dateFormat = (date: Date) => {
  return format(date, 'YYYY/MM/DD HH:mm')
}

const examsInfo = computed(() => {
  return exams.value.map((exam) => {
    const base = {
      id: exam.id,
      name: exam.name,
      image: exam.image && exam.image.url ? exam.image.url : exam.examImageUrl,
      price: exam.price,
      difficultRate: exam.difficultRate,
      passRate: exam.passRate,
      averageRate: exam.averageRate,
      usersCount: exam.usersCount
    }

    const testInfo = {
      hasTested: false,
      description: '',
      to: `/classroom/exam-list/${exam.id}`
    }

    if (exam.userExams.length > 0) {
      testInfo.hasTested = true
      const userExam = exam.userExams[0]

      if (userExam.finishedAt) {
        testInfo.description = `${dateFormat(userExam.createdAt)}に実行済み`
        testInfo.to = `/classroom/my-exams/${exam.id}/result`
      } else {
        testInfo.description = `${dateFormat(userExam.createdAt)}に受け済み`
        testInfo.to = `/classroom/my-exams/${exam.id}`
      }
    }
    return {
      ...base,
      ...testInfo
    }
  })
})

const getSearchValue = async () => {
  if (search.value) {
    search.value = ''
  }
}

const clickCategory = (category: Category) => {
  router.push({ query: { list_id: category.id.toString() } })
}

const selectPage = (page: number) => {
  examState.getList(page)
}

const onResize = () => {
  isMobile.value = window.innerWidth < 600
}

const resetCategory = () => {
  router.push({ query: {} })
}

watch(() => route.query, async () => {
  const listId = currentListId.value
  await examState.getList(1, listId)
}, { immediate: true })

watch(search, async () => {
  if (search.value) {
    await examState.searchExam(search.value)
  } else {
    const listId = currentListId.value
    await examState.getList(1, listId)
  }
})

onMounted(async () => {
  await examState.getCategories()
  headerState.setTitle('テスト一覧')
  footerState.setFooterDefault()
  onResize()
  window.addEventListener('resize', onResize)
})

onBeforeUnmount(() => {
  if (typeof window !== 'undefined') {
    window.removeEventListener('resize', onResize)
  }
})

return (_ctx: any,_cache: any) => {
  const _component_AppBreadcrumb = _resolveComponent("AppBreadcrumb")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_combobox = _resolveComponent("v-combobox")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_pagination = _resolveComponent("v-pagination")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_AppBreadcrumb, { items: [
      { text: 'クラスルーム', to: '/classroom/' },
      { text: 'テスト一覧' }
    ] }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_col, {
        lg: "8",
        cols: "12",
        class: "exam-list pt-3 bg-white ms-3"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_v_col, { lg: "10" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_tabs, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_tab, { to: "/classroom/my-exams" }, {
                      default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                        _createTextVNode("マイテスト", -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    }),
                    _createVNode(_component_v_tab, { to: "/classroom/exam-list" }, {
                      default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                        _createTextVNode("テスト一覧", -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_v_col, { cols: "8" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_combobox, {
                      modelValue: model.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
                      items: items.value,
                      loading: isLoadingSearch.value,
                      search: search.value,
                      "onUpdate:search": _cache[1] || (_cache[1] = ($event: any) => ((search).value = $event)),
                      placeholder: "テスト名入力してください",
                      "prepend-icon": "mdi-database-search"
                    }, null, 8 /* PROPS */, ["modelValue", "items", "loading", "search"])
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_v_col, { cols: "2" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  class: "me-2 search-test",
                  onClick: getSearchValue
                }, {
                  default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                    _createTextVNode(" クリア ", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            })
          ]),
          (!isLoading.value)
            ? (_openBlock(), _createBlock(_component_v_list, {
                key: 0,
                "three-line": ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(examsInfo.value, (examInfo) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: examInfo.id
                    }, [
                      _createVNode(_component_v_list_item, {
                        to: examInfo.to,
                        class: _normalizeClass({ 'px-0': isMobile.value }),
                        cytag: "exam-item"
                      }, _createSlots({
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => [
                              (examInfo.price > 0)
                                ? (_openBlock(), _createBlock(_component_v_chip, {
                                    key: 0,
                                    color: "orange",
                                    "text-color": "white",
                                    label: ""
                                  }, {
                                    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                      _createTextVNode("有料", -1 /* CACHED */)
                                    ]))]),
                                    _: 1 /* STABLE */
                                  }))
                                : _createCommentVNode("v-if", true),
                              _createElementVNode("span", _hoisted_5, _toDisplayString(examInfo.name), 1 /* TEXT */),
                              (examInfo.price > 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(examInfo.price.toLocaleString()) + "円", 1 /* TEXT */))
                                : _createCommentVNode("v-if", true)
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1024 /* DYNAMIC_SLOTS */),
                          (examInfo.hasTested)
                            ? (_openBlock(), _createBlock(_component_v_list_item_title, { key: 0 }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", _hoisted_7, _toDisplayString(examInfo.description), 1 /* TEXT */)
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1024 /* DYNAMIC_SLOTS */))
                            : _createCommentVNode("v-if", true),
                          _createVNode(_component_v_list_item_subtitle, null, {
                            default: _withCtx(() => [
                              _createElementVNode("p", _hoisted_8, [
                                _cache[11] || (_cache[11] = _createElementVNode("span", { class: "mt-n2" }, "レベル", -1 /* CACHED */)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Array.from(Array(examInfo.difficultRate).keys()), (item, index) => {
                                  return (_openBlock(), _createElementBlock("img", {
                                    key: index,
                                    style: {"width":"20px"},
                                    class: "icon",
                                    src: "/images/icons/theme/general/star.svg",
                                    "data-inject-svg": ""
                                  }))
                                }), 128 /* KEYED_FRAGMENT */))
                              ]),
                              _createElementVNode("div", _hoisted_9, [
                                _createVNode(_component_v_col, { lg: "3" }, {
                                  default: _withCtx(() => [
                                    _cache[12] || (_cache[12] = _createElementVNode("img", {
                                      style: {"width":"20px"},
                                      class: "icon",
                                      src: "/images/icons/theme/communication/group.svg",
                                      "data-inject-svg": ""
                                    }, null, -1 /* CACHED */)),
                                    _createTextVNode(" " + _toDisplayString(examInfo.usersCount), 1 /* TEXT */)
                                  ]),
                                  _: 2 /* DYNAMIC */
                                }, 1024 /* DYNAMIC_SLOTS */),
                                _createVNode(_component_v_col, { lg: "3" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("合格率 " + _toDisplayString(examInfo.passRate) + "%", 1 /* TEXT */)
                                  ]),
                                  _: 2 /* DYNAMIC */
                                }, 1024 /* DYNAMIC_SLOTS */),
                                _createVNode(_component_v_col, { lg: "3" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("平均 " + _toDisplayString(examInfo.averageRate) + "%", 1 /* TEXT */)
                                  ]),
                                  _: 2 /* DYNAMIC */
                                }, 1024 /* DYNAMIC_SLOTS */)
                              ])
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1024 /* DYNAMIC_SLOTS */)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, [
                        (!isMobile.value)
                          ? {
                              name: "prepend",
                              fn: _withCtx(() => [
                                _createVNode(_component_v_img, {
                                  "min-height": "100",
                                  "min-width": "100",
                                  "max-height": "100",
                                  "max-width": "100",
                                  src: examInfo.image
                                }, null, 8 /* PROPS */, ["src"])
                              ]),
                              key: "0"
                            }
                          : undefined
                      ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["to", "class"]),
                      _createVNode(_component_v_divider, { class: "my-0" })
                    ], 64 /* STABLE_FRAGMENT */))
                  }), 128 /* KEYED_FRAGMENT */))
                ]),
                _: 1 /* STABLE */
              }))
            : _createCommentVNode("v-if", true),
          (exams.value.length > 0)
            ? (_openBlock(), _createBlock(_component_v_pagination, {
                key: 1,
                modelValue: pagination.value.page,
                "onUpdate:modelValue": [
                  _cache[2] || (_cache[2] = ($event: any) => ((pagination.value.page) = $event)),
                  selectPage
                ],
                length: pagination.value.totalPages,
                class: "mt-4 mb-5"
              }, null, 8 /* PROPS */, ["modelValue", "length"]))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }),
      (!isMobile.value)
        ? (_openBlock(), _createBlock(_component_v_col, {
            key: 0,
            lg: "3",
            cols: "12",
            class: "pt-0 bg-white"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_10, [
                _cache[13] || (_cache[13] = _createElementVNode("div", { class: "gray--text fs-4 fw-bold" }, "カテゴリー", -1 /* CACHED */)),
                _createElementVNode("a", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("h5", {
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (resetCategory())),
                      class: "mb-1"
                    }, "すべてのテスト"),
                    _createVNode(_component_v_divider)
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value, (category, index) => {
                  return (_openBlock(), _createElementBlock("div", { key: index }, [
                    _createVNode(ExamListCategory, {
                      exams: exams.value,
                      category: category,
                      padding: 16,
                      onClickCategory: clickCategory
                    }, null, 8 /* PROPS */, ["exams", "category"])
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true)
    ]),
    _createCommentVNode(" Header "),
    (_openBlock(), _createBlock(_Teleport, { to: "#header-right" }, [
      (mobile.value)
        ? (_openBlock(), _createBlock(_component_v_btn, {
            key: 0,
            icon: "",
            onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (drawerRight.value = !drawerRight.value), ["stop"]))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                  _createTextVNode("menu", -1 /* CACHED */)
                ]))]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true)
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "#header-right-drawer" }, [
      (mobile.value)
        ? (_openBlock(), _createBlock(_component_v_navigation_drawer, {
            key: 0,
            modelValue: drawerRight.value,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((drawerRight).value = $event)),
            location: "right",
            temporary: ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_13, [
                _cache[15] || (_cache[15] = _createElementVNode("div", { class: "gray--text fs-4 fw-bold" }, "カテゴリー", -1 /* CACHED */)),
                _createElementVNode("a", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("h5", {
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (resetCategory())),
                      class: "mb-1"
                    }, "すべてのテスト"),
                    _createVNode(_component_v_divider)
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value, (category, index) => {
                  return (_openBlock(), _createElementBlock("div", { key: index }, [
                    _createVNode(ExamListCategory, {
                      exams: exams.value,
                      category: category,
                      padding: 0,
                      onClickCategory: clickCategory
                    }, null, 8 /* PROPS */, ["exams", "category"])
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["modelValue"]))
        : _createCommentVNode("v-if", true)
    ]))
  ]))
}
}

})